import { DetailCard } from "@hatch-digital-nl/abs-storybook/legacy";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { CertificateInterface } from "../../../common/interfaces/CertificateInterface";
import { PostActionType, Refetch } from "../../../common/types/Types";
import { getUserFullName } from "../../../common/utils/getUserFullName";
import React, { JSX } from "react";
import { getReviewCardActionData } from "../utils/getReviewCardActionData";
import { getReviewCardMetadata } from "../utils/getReviewCardMetadata";

interface ReviewCardProps {
    certificate: CertificateInterface;
    refetch: Refetch;
    tagRef: React.RefObject<HTMLDivElement | null>;
    patchCertificate: PostActionType;
}

export const ReviewCard = (props: ReviewCardProps): JSX.Element => {
    const { certificate, refetch, tagRef, patchCertificate } = props;
    const { selectedCertificateId, isOpenFormLoading } = useAppSelector(
        (state) => state.editCertificateModal,
    );
    const {
        acceptIsLoading,
        currentProcessingId,
        isLeftTagModalOpenIndex,
        isRightTagModalOpenIndex,
    } = useAppSelector((state) => state.review);

    const dispatch = useAppDispatch();

    const personName = getUserFullName(certificate.employee.user);
    const isAcceptLoading =
        acceptIsLoading && currentProcessingId === certificate.id;
    const isEditLoading =
        isOpenFormLoading && selectedCertificateId === certificate.id;

    return (
        <DetailCard
            key={certificate.id}
            subtitle={personName ? { label: personName } : undefined}
            title={certificate.qualification.name}
            metadata={getReviewCardMetadata({
                certificate,
                dispatch,
                tagRef,
                isLeftTagModalOpenIndex,
                isRightTagModalOpenIndex,
            })}
            actions={getReviewCardActionData({
                certificate,
                dispatch,
                patchCertificate,
                refetch,
                isAcceptLoading,
                isEditLoading,
            })}
        />
    );
};
